var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack620({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.58,3.91h1.59v5A5.31,5.31,0,0,1,10,10.4a2.18,2.18,0,0,1-.84,1.1,2.78,2.78,0,0,1-1.6.42,2.37,2.37,0,0,1-1.8-.66,2.63,2.63,0,0,1-.63-1.91l1.5-.17a2,2,0,0,0,.2,1,.84.84,0,0,0,.78.43.84.84,0,0,0,.75-.31A2.33,2.33,0,0,0,8.58,9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack620);
export default __webpack_public_path__ + "static/media/Symbolpack_6_20.92e09c24afabc8a11fe5a87f16d891a3.svg";
export { ForwardRef as ReactComponent };